import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=3202d1e5"
import script from "./Option.vue?vue&type=script&lang=ts"
export * from "./Option.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports